import { render, staticRenderFns } from "./PromotionContent.vue?vue&type=template&id=02362220&scoped=true&"
import script from "./PromotionContent.vue?vue&type=script&lang=js&"
export * from "./PromotionContent.vue?vue&type=script&lang=js&"
import style0 from "./PromotionContent.vue?vue&type=style&index=0&id=02362220&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02362220",
  null
  
)

export default component.exports